import type { TextareaHTMLAttributes } from 'react';
import { type FieldShellProps, FormField } from './FormField';

type NativeProps = Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  'id' | 'className' | 'required'
>;

interface TextAreaProps extends FieldShellProps, NativeProps {}

export function TextArea({
  label,
  hideLabel,
  error,
  helpText,
  required,
  className,
  rows = 3,
  ...textarea
}: TextAreaProps) {
  return (
    <FormField
      label={label}
      hideLabel={hideLabel}
      error={error}
      helpText={helpText}
      required={required}
      className={className}
    >
      {({ id, describedBy, invalid }) => (
        <textarea
          {...textarea}
          id={id}
          rows={rows}
          required={required}
          aria-describedby={describedBy}
          aria-invalid={invalid || undefined}
          className="c-input__control c-input__control--textarea"
        />
      )}
    </FormField>
  );
}
